module.exports = __webpack_public_path__ + "static/media/project3.a5f9b888.png";